import { isDemon, isGoblin } from '@library/utils';
import Demon from '@library/assets/images/icons/demon.png';
import Goblin from '@library/assets/images/icons/goblin.png';
import type { OddsType } from '@library/types/projection';

export interface OddsTypeIndicatorProps {
  className?: string;
  iconClassName?: string;
  oddsType: OddsType;
}

export const OddsTypeIndicator = ({
  className = '',
  iconClassName = 'w-8 self-start',
  oddsType
}: OddsTypeIndicatorProps) => {
  const showGoblin = isGoblin(oddsType);
  const showDemon = isDemon(oddsType);

  return (
    <div className={className}>
      {showGoblin && (
        <img src={Goblin} alt="Goblin" className={iconClassName} />
      )}
      {showDemon && <img src={Demon} alt="Demon" className={iconClassName} />}
    </div>
  );
};
